import React from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from '@components/Avatar';
import Skeleton from '@components/Skeleton';
import { useAuthorizationContext } from '@src/context/AuthorizationContext';

const Profile = () => {
  const employeeDetail = useAuthorizationContext();
  const { t } = useTranslation();

  return (
    <div
      data-test-id="user-profile-section"
      className="flex items-center border-b pl-5"
    >
      <div className="w-full flex items-center">
        <Avatar size={6} name={employeeDetail?.emp_name} />
        <div className="p-3">
          <p className="text-sm text-neutral-80" data-testid="logged-in-label">
            {t('header.logged_in_as')}:
          </p>
          {employeeDetail.isLoading ? (
            <Skeleton className="h-6 w-32" />
          ) : (
            <h3 className="text-base font-medium" data-testid="user-name">
              {employeeDetail?.emp_name}
            </h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
